export const POPOVER_ANCHOR_ORIGIN = { vertical: 'bottom', horizontal: 'left' };
